import Vue from 'vue'
import store from '@/store/index'

// Routes we can never send someone back to after login.
const NOT_A_TARGET = ['Login', 'Signup']

// Only keep what push() needs. A full route object holds component
// instances and can't be serialised.
const toTarget = (route) => ({
    name: route.name,
    params: route.params || {},
    query: route.query || {}
})

export const setRoute = (route) => {
    if (!route || !route.name || NOT_A_TARGET.includes(route.name)) {
        return
    }
    store.commit('SET_ROUTE_TO', toTarget(route))
}

// During the first navigation of a page load the router hasn't caught up,
// so currentRoute is still the start route. The address bar is the truth.
export const currentTargetRoute = () => {
    const router = Vue.router
    if (!router) {
        return null
    }
    let route = null
    try {
        route = router.resolve(window.location.pathname + window.location.search).route
    } catch (e) {
        route = null
    }
    if (!route || !route.name) {
        route = router.currentRoute
    }
    return route && route.name ? route : null
}

export const authOptions = {
    redirect: (transition) => {
        if (!Vue.auth.check()) {
            setRoute(transition)
            return '/login'
        }
    },
}

export const getAccessToken = () => {
    const authToken = JSON.parse(Vue.auth.token() || '{}')
    return authToken.access
}

export const getAccessTokenAsync = async () => {
    if (Vue.auth.token()) {
        try {
            await Vue.auth.refresh()
        } catch (e) {
            console.log('errored in getting the authToken', e)
        }
    }
    const authToken = JSON.parse(Vue.auth.token() || '{}')
    return authToken.access
}
